import { render, staticRenderFns } from "./OrthoPackage.vue?vue&type=template&id=faf36246"
import script from "./OrthoPackage.vue?vue&type=script&lang=js"
export * from "./OrthoPackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports